import request from '@/plugins/request';
import utils from '@/utils';
import { API_URL } from '@/const';
import { IUser } from '@/types/models';
import { AxiosResponse } from 'axios';
import { IBoolResult } from '@/types/dto';

const $url = '/profile';
const $urlUpload = '/profile/actions/upload';
const $urlSendSms = '/profile/actions/sendSms';
const $urlVerifyMobile = '/profile/actions/verifyMobile';

interface IGetResult {
  isSmsEnabled: boolean;
  isUserVerifyMobile: boolean;
  user: IUser;
}

interface ISendSmsRequest {
  mobile: string;
}

interface IVerifyMobileRequest {
  mobile: string;
  code: string;
}

interface ISubmitRequest {
  userName: string;
  avatarUrl: string;
  mobile: string;
  mobileVerified: boolean;
}

export default {
  getUploadUrl() {
    return API_URL + $urlUpload;
  },

  get(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  sendSms(req: ISendSmsRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);

    request
      .post($urlSendSms, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error, true);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  verifyMobile(req: IVerifyMobileRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);

    request
      .post($urlVerifyMobile, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.loading(false);
        utils.error(error, true);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
